

interface DimensionTabsProps {
  active: string;
  onChange: (dimension: string) => void;
  dimensions?: string[];
}

const DEFAULT_DIMENSIONS = ['人设', '技能', '工作流', '记忆', '工具', '知识', '快照'];

export default function DimensionTabs({ active, onChange, dimensions = DEFAULT_DIMENSIONS }: DimensionTabsProps) {
  return (
    <div className="dimension-tabs">
      {dimensions.map((dim) => (
        <button
          key={dim}
          className={`dimension-tab ${active === dim ? 'active' : ''}`}
          onClick={() => onChange(dim)}
        >
          {dim}
        </button>
      ))}
    </div>
  );
}
